import React, { useState } from 'react';

import {
  Container,
  Left,
  Right,
  Title,
  Subtitle,
  CloseButton,
  CloseIcon,
  ConfirmButton,
  Text,
  TextContainer,
} from './styles';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { htmlT } from 'utils/generic';
import { useHistory } from 'react-router';
import { goBackToApp } from 'utils/webViewUtils';
import useIsInsideApp from 'hooks/useIsInsideApp';
import { onUserLogout, updateAccount } from 'actions/user';

interface Props {
  subtitle?: string | JSX.Element;
  onClose?: () => void;
  highlight?: boolean;
  showModal?: boolean;
}

const ModalSessionToken = ({ subtitle, onClose, highlight, showModal }: Props) => {
  const userData = useSelector((state: RootState) => state.user.accountResult);
  const history = useHistory();
  const isInsideApp = useIsInsideApp();
  const [bShowModal, setBShowModal] = useState(userData?.bIsSessionToken)
  const { t } = useStoreTranslation();
  const dispatch = useDispatch();
  const handleLogout = () => {
    updateAccount(dispatch, { ...userData, bIsSessionToken: false });
    setBShowModal(false);
    if (isInsideApp) {
      goBackToApp();
      return;
    }
    dispatch(onUserLogout());


  };
  if (!userData?.bIsSessionToken) return null;
  return (
    <div>
      <Container className={highlight ? 'highlight' : ''}>
        <Left>
          <Title $subtitle={subtitle ? true : false}>{t('sessionToken.title')}</Title>
          {subtitle && <Subtitle>{subtitle}</Subtitle>}
        </Left>
        {onClose && (
          <Right>
            <CloseButton onClick={onClose}>
              <CloseIcon />
            </CloseButton>
          </Right>
        )}
      </Container>
      <TextContainer>
        <Text>{htmlT(t, 'sessionToken.subtitle', { name: `${userData.name} ${userData.lastName}` })}</Text>
        <Text>{htmlT(t, 'sessionToken.text')}</Text>
        <ConfirmButton onClick={handleLogout} testId="flight-details-select-button">
          {t('sessionToken.button')}
        </ConfirmButton>
      </TextContainer>
    </div>
  );
};

export default ModalSessionToken;
